
import { showUpdateToast } from './refreshPrompt';

export function startVersionPolling(intervalMs = 60000) {
  let current = null;
  let timer = null;

  const check = async () => {
    try {
      const res = await fetch('/version.txt', { cache: 'no-store' });
      if (!res.ok) throw new Error('version.txt not available');
      const id = (await res.text()).trim();
      if (current && id && id !== current) {
        const hardReload = () => {
          try {
            const url = new URL(window.location.href);
            url.searchParams.set('_ts', Date.now().toString()); 
            window.location.replace(url.toString());
          } catch (e) {
            
            window.location.reload();
          }
        };
        showUpdateToast(hardReload);
        
      }
      if (id) current = id;
    } catch (e) {

    } finally {
      timer = setTimeout(check, intervalMs);
    }
  };

  check();
  return () => {
    if (timer) clearTimeout(timer);
  };
}


export function ensureVersionPolling(intervalMs = 60000) {
  
  const g = (typeof window !== 'undefined') ? window : {};
  if (!g.__aajVersionPolling) {
    g.__aajVersionPolling = { started: false, stop: null };
  }
  if (!g.__aajVersionPolling.started) {
    g.__aajVersionPolling.stop = startVersionPolling(intervalMs);
    g.__aajVersionPolling.started = true;
  }
  return g.__aajVersionPolling.stop;
}
